<template>
    <div>
        <a-modal :title="$t('selectOfflineCountResult')" :visible="visible" @cancel	="cancel" width="80%" :footer="null" :maskClosable="false">
            <a-row>
                <a-button size="small" type="primary" class="mg5" @click="queryList">{{$t('job.Query')}}</a-button>
                <a-button size="small" type="primary" class="mg5" @click="resetQuery">{{$t('job.Reset')}}</a-button>
                <a-button size="small" type="primary" class="mg5" @click="importList">{{$t('roleGe.Import')}}</a-button>
                <a-button size="small" type="primary" class="mg5" @click="removeQuery">{{$t('pubGicSet.Remove')}}</a-button>
            </a-row>
            <a-row>
                <a-form :form="formQuery">
                        <a-col :span="3" style="margin-left: 5px;">
                            <a-form-item :label="$t('generic.Creator')" class="genericFrom">
                                <a-input size="small" v-decorator="['creator']"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" offset="1">
                            <a-form-item :label="$t('countDateFrom')" class="genericFrom">
                                <a-date-picker size="small" allowClear showTime v-decorator="['countDateFrom']"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" offset="1">
                            <a-form-item :label="$t('countDateTo')" class="genericFrom">
                                <a-date-picker size="small" allowClear showTime v-decorator="['countDateTo']"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" offset="1">
                            <a-form-item :label="$t('pubGicSet.SKU')" class="genericFrom">
                                <a-input size="small" v-decorator="['skuUpc']"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" offset="1">
                            <a-form-item :label="$t('pubGicSet.Location')" class="genericFrom">
                                <a-input size="small" v-decorator="['location']"/>
                            </a-form-item>
                        </a-col>
                </a-form>
            </a-row>
            <a-row>
                <a-col align="right" style="margin: 20px -7px 5px 0">
                    <a-pagination
                            :pageSizeOptions="pageSizeOptions"
                            :showTotal="total => $t('job.Total') + ` ${pagingTotal} `+$t('job.Records')"
                            size="small"
                            :total="pagingTotal"
                            v-model="currentVal"
                            :pageSize.sync="pagingSize"
                            @change="tableChangePage"
                            @showSizeChange="onShowSizeChange"
                            :showSizeChanger="showSizeChanger"
                            :showQuickJumper="showQuickJumper"
                    />
                </a-col>
            </a-row>
            <a-row>
                <vxe-table
                        border
                        resizable
                        stripe
                        column-key
                        highlight-hover-column
                        highlight-hover-row
                        highlightCurrentRow
                        show-header-overflow
                        show-overflow="title"
                        :sort-config="{multiple: true, trigger: 'cell'}"
                        :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                        keep-source
                        :keyboard-config="{isArrow: true}"
                        :checkbox-config="{trigger: 'row', highlight: true, range: true}"
                        align="center"
                        :data.sync="PagingGridList"
                        class="mytable-style "
                        ref="refPagingGrid"
                        size="mini">
                    <template v-slot:empty>
                        <a-empty></a-empty>
                    </template>
                    <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                    <vxe-table-column field="uid" title="UID" show-header-overflow="ellipsis" show-overflow="title" :visible="false"></vxe-table-column>
                    <vxe-table-column field="projectCode" :title="$t('generic.Project')" sortable></vxe-table-column>
                    <vxe-table-column field="location" :title="$t('pubGicSet.Location')" sortable></vxe-table-column>
                    <vxe-table-column field="skuUpc" :title="$t('pubGicSet.SKU')" sortable></vxe-table-column>
                    <vxe-table-column field="countedQty" :title="$t('countedQty')" sortable></vxe-table-column>
                    <vxe-table-column field="uom" :title="$t('pubGicSet.UOM')" sortable></vxe-table-column>
                    <vxe-table-column field="po" :title="$t('po')" sortable></vxe-table-column>
                    <vxe-table-column field="packFactor" :title="$t('packFactor')" sortable></vxe-table-column>
                    <vxe-table-column field="importMsg" :title="$t('importMsg')" sortable></vxe-table-column>
                    <vxe-table-column field="creator" :title="$t('generic.Creator')" sortable></vxe-table-column>
                    <vxe-table-column field="createTime" :title="$t('generic.CreateTime')" sortable></vxe-table-column>
                    <vxe-table-column field="uploadTime" :title="$t('uploadTime')" sortable></vxe-table-column>
                </vxe-table>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
    import ajax from "../../api/ajax";
    import api from "../../api/url";
    import moment from 'moment'
    export default{
        data(){
            return{
                visible: false,
                formQuery:this.$form.createForm(this),
                pagingTotal: 0, // 总数
                pagingSize:  10, // 条数
                currentVal: 1, // 当前选中的页数
                showSizeChanger:true,//是否显示页码下拉框
                showQuickJumper:false,//是否显示快速跳转输入框
                pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
                PagingGridList: [],
                scUid:'',
            }
        },
        methods:{
            moment,
            show(val){
                this.scUid = val
                this.visible = true
                this.formQuery.resetFields();
                this.queryList();
            },
            cancel(){
                this.visible = false
            },
            tableChangePage(current) {
                this.currentVal = current;
                this.queryList();
            },
            onShowSizeChange(current, pageSize) {
                this.currentVal = current;
                this.pagingSize = pageSize;
                this.queryList();
            },
            resetQuery(){
                this.formQuery.resetFields();
            },
            queryList(){
                this.formQuery.validateFields((err, values) => {
                    if(err){
                        this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
                        return;
                    }
                    if(values){
                        let params = {
                            createTimeStart : values.countDateFrom,
                            createTimeEnd : values.countDateTo,
                            creator : values.creator,
                            skuUpc : values.skuUpc,
                            location : values.location,
                            currentVal : this.currentVal,
                            pagingSize : this.pagingSize,
                        }
                        ajax.post(api.GETSELECTOFFLINECOUNTRESULTLIST,params).then(res=>{
                            if(res.code == 200){
                                this.PagingGridList = res.data;
                                this.pagingTotal = res.total;
                            }
                        })
                    }
                });
            },
            removeQuery(){
                let Records = this.$refs.refPagingGrid.getCheckboxRecords()
                if(Records.length == 0){
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 2);
                    return;
                }
                let uidList = [];
                for(let i in Records){
                    uidList.push(Records[i].uid)
                }
                let that = this;
                this.$customConfirm({
                    title: this.$t('pubGicSet.AreyoudeleTask'),
                    okText: this.$t('publicLang.Confirm'),
                    cancelText: this.$t('publicLang.Cancel'),
                    content: "",
                    onOk() {
                        ajax.post(api.DELETESELECTOFFLINECOUNTRESULT, uidList).then(res => {
                            if (res.code == 200) {
                                that.queryList()
                                that.$message.success(that.$t("publicLang.DeleteSuccess"));
                            } else {
                                that.$customMessage.error(res.msg);
                            }
                        })
                    }
                });
            },
            importList(){
                if(!this.scUid){
                    this.$customMessage.warning(this.$t('pubGicSet.NoRecordfound'), 2);
                    return;
                }
                let Records = this.$refs.refPagingGrid.getCheckboxRecords()
                if(Records.length == 0){
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 2);
                    return;
                }
                let uidList = [];
                for(let i in Records){
                    uidList.push(Records[i].uid)
                }
                let postData = {
                    uidList: uidList,
                    scUid: this.scUid
                };
                let that = this;
                this.$customConfirm({
                    title: this.$t('AreYouImportTask'),
                    okText: this.$t('publicLang.Confirm'),
                    cancelText: this.$t('publicLang.Cancel'),
                    content: "",
                    onOk() {
                        ajax.post(api.IMPORTSELECTOFFLINECOUNTRESULT, postData).then(res => {
                            if (res.code == 200) {
                                that.$message.success(res.data +" "+ that.$t("cfs.operationSuccess"));
                            } else {
                                that.$customMessage.error(res.msg);
                            }
                            that.queryList()
                        })
                    }
                });
            },
        }
    }
</script>